import {isFeatureEnabled} from 'feature-flags';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {BusinessCaseInternalType} from '@dms/api/sales';
import {featureFlags} from '@dms/feature-flags';

import {Nullish} from 'shared/web';

interface ShouldOfferCombinedOnlineOfferParams {
  businessCaseInternalType: BusinessCaseInternalType | Nullish;
  buyingVehicleId: string | Nullish;
  canSendBuyingOnlineOffer: boolean;
  linkedTradeInBusinessCaseId: string | Nullish;
}

export function shouldOfferCombinedOnlineOffer(props: ShouldOfferCombinedOnlineOfferParams) {
  return (
    isFeatureEnabled(featureFlags.BUYING_ONLINE_OFFER) &&
    props.businessCaseInternalType === 'SELLING' &&
    isNotNilOrEmpty(props.linkedTradeInBusinessCaseId) &&
    isNotNilOrEmpty(props.buyingVehicleId) &&
    props.canSendBuyingOnlineOffer
  );
}
